var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['text', _vm.textTheme,_vm.hasTextMargin ? 'margin-text' : ''],style:(_vm.themeStyle),on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.textValue))])}
var staticRenderFns = []

export { render, staticRenderFns }